import { render, staticRenderFns } from "./OmniButtonCollection.vue?vue&type=template&id=1bf4c378&"
import script from "./OmniButtonCollection.vue?vue&type=script&lang=js&"
export * from "./OmniButtonCollection.vue?vue&type=script&lang=js&"
import style0 from "./OmniButtonCollection.vue?vue&type=style&index=0&id=1bf4c378&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports